import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isEdit: false,
};

const adminAgentInfoSlice = createSlice({
  name: "ADMIN_AGENT_INFO_SLICE",
  initialState,
  reducers: {
    SET_IS_EDIT: (state, action: PayloadAction<boolean>) => {
      state.isEdit = action.payload;
    },
  },
});

export const { SET_IS_EDIT } = adminAgentInfoSlice.actions;

export default adminAgentInfoSlice.reducer;
